module.exports = __webpack_public_path__ + "static/media/Vandpunkten-image.4ec3a6bf.jpg";